import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SigninForm from './components/SigninForm'
import { useSchool } from '@/hooks'
import LoadingScreen from '@/components/LoadingScreen'

export default function SignInPage() {
  const { t } = useTranslation()
  const { schoolSlug } = useParams()
  const navigate = useNavigate()

  const { data, isLoading } = useSchool(schoolSlug)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!schoolSlug) {
    navigate('/')
  } else {
    return (
      <>
        <title>Login - Book Blast by Books Are Fun</title>
        <div className='w-full lg:w-3/4 mx-auto'>
          <div className='bg-cta text-center px-4 md:px-8'>
            <h1 className='text-white text-3xl font-serif text-center font-bold'>{t('content.signin_page.title')}</h1>
            <div className='text-white pt-2'>{t('content.signin_page.subtitle')}</div>
          </div>
          <SigninForm
            schoolSlug={schoolSlug}
            schoolName={data?.schoolName || ''}
            schoolLogo={data?.schoolLogo || undefined}
          />
        </div>
      </>
    )
  }
}
